import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=61fadc8f&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=61fadc8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fadc8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fadc8f')) {
      api.createRecord('61fadc8f', component.options)
    } else {
      api.reload('61fadc8f', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=61fadc8f&scoped=true&", function () {
      api.rerender('61fadc8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarPlugin/SidebarItem.vue"
export default component.exports